export default __webpack_public_path__ + "static/RootSans-2ThinItalic-1e71204f4771726fdb397be5e1730d3d.woff2";